var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgCharge27 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.927,
    cy: 13.438,
    r: 11.315,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M13.25 19.132c-.055.082-.201.037-.184-.056l.917-4.979c.01-.051-.037-.098-.098-.098h-3.31c-.076 0-.124-.071-.086-.128l4.397-6.5c.055-.08.2-.038.184.054l-.805 5.01c-.008.052.038.097.098.097h3.184c.076 0 .124.071.085.128l-4.382 6.472Z"
  })));
});
SvgCharge27.displayName = "SvgCharge27";
export default SvgCharge27;